import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import a1 from "./assets/documents/img_report.pdf";
import a2 from "./assets/images/spravka.png";
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import "./main.css";
import "./responsive.css";

const StepCard = ({ number, text }) => {
  return (
    <div className="step-card">
      <div className="step-number">{number}</div>
      <p>{text}</p>
    </div>
  );
};

const generateRandomData = (count) => {
  const regions = ["Московская область", "Республика Бурятия", "Краснодарский край", "Челябинская область"];
  const results = ["Въезд запрещен!", "Разрешен"];
  const names = ["Иванов", "Петров", "Сидоров", "Козлов"];
  const initials = ["П.В.", "И.И.", "А.М.", "Д.С."];

  const getRandomDate = () => {
    const start = new Date(1970, 0, 1);
    const end = new Date(2005, 11, 31);
    const date = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
    return date.toISOString().split('T')[0];
  };

  const getRandomRequestDateTime = () => {
    const now = new Date();
    const start = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    const date = new Date(start.getTime() + Math.random() * (now.getTime() - start.getTime()));
    return date.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).replace(',', '');
  };

  return Array.from({ length: count }, () => ({
    fullName: `****${names[Math.floor(Math.random() * names.length)]} ${initials[Math.floor(Math.random() * initials.length)]}`,
    region: regions[Math.floor(Math.random() * regions.length)],
    dob: getRandomDate(),
    requestDateTime: getRandomRequestDateTime(),
    result: results[Math.floor(Math.random() * results.length)]
  }));
};

function RandomCheckTable() {
  const [tableData] = useState(generateRandomData(5));

  return (
    <div className="random-check-table">
      <table>
        <thead>
          <tr>
            <th className="random-check-table-th">ФИО</th>
            <th>Регион проверки</th>
            <th>Дата рождения</th>
            <th>Дата и время запроса</th>
            <th className="random-check-table-th2">Результат проверки</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index}>
              <td>{row.fullName}</td>
              <td>{row.region}</td>
              <td>{row.dob}</td>
              <td>{row.requestDateTime}</td>
              <td className={row.result === "Въезд запрещен!" ? "result-denied" : "result-allowed"}>{row.result}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function FullNameInput({ onValidChange, onChange }) {
  const [fullName, setFullName] = useState('');
  const [error, setError] = useState('');

  const validate = (value) => {
    const words = value.trim().split(/\s+/);
    const onlyLetters = /^[А-Яа-яЁёA-Za-z\s\-]+$/;

    if (!value) {
      return 'Введите ФИО';
    } else if (!onlyLetters.test(value)) {
      return 'Только буквы, пробелы, дефисы';
    } else if (words.length !== 3) {
      return 'Фамилия, имя, отчество';
    } else {
      return '';
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setFullName(value);
    const errorText = validate(value);
    setError(errorText);
    if (onValidChange) {
      onValidChange(errorText === '');
    }
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="form-group">
      <label>Укажите ваше ФИО(По-Русски)</label>
      <input
        type="text"
        placeholder="Иванов Иван Иванович"
        className={`form-input ${error ? 'is-invalid' : ''}`}
        value={fullName}
        onChange={handleChange}
      />
      {error && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '6px' }}>{error}</div>}
    </div>
  );
}

function StepTwoForm({ onValidChange, onDataChange }) {
  const [citizenship, setCitizenship] = useState('');
  const [fullNameLatin, setFullNameLatin] = useState('');
  const [documentType, setDocumentType] = useState('');
  const [documentNumber, setDocumentNumber] = useState('');
  const [validityDate, setValidityDate] = useState('');
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!citizenship) newErrors.citizenship = 'Выберите гражданство';
    if (!fullNameLatin) {
      newErrors.fullNameLatin = 'Введите ФИО на латинице';
    } else if (!/^[A-Za-z\s\-]+$/.test(fullNameLatin)) {
      newErrors.fullNameLatin = 'Только латинские буквы, пробелы, дефисы';
    } else {
      const words = fullNameLatin.trim().split(/\s+/);
      if (words.length !== 3) newErrors.fullNameLatin = 'Фамилия, имя, отчество';
    }
    if (!documentType) newErrors.documentType = 'Выберите тип документа';
    if (!documentNumber) {
      newErrors.documentNumber = 'Введите номер документа';
    } else if (!/^[A-Za-z0-9]+$/.test(documentNumber)) {
      newErrors.documentNumber = 'Только буквы и цифры';
    }
    if (!validityDate) newErrors.validityDate = 'Выберите дату';

    setErrors(newErrors);
    const isValid = Object.keys(newErrors).length === 0;
    if (onValidChange) {
      onValidChange(isValid);
    }
    if (onDataChange && isValid) {
      onDataChange({ citizenship, fullNameLatin, documentNumber, validityDate });
    }
    return isValid;
  };

  const handleChange = (field, value) => {
    switch (field) {
      case 'citizenship':
        setCitizenship(value);
        break;
      case 'fullNameLatin':
        setFullNameLatin(value);
        break;
      case 'documentType':
        setDocumentType(value);
        break;
      case 'documentNumber':
        setDocumentNumber(value);
        break;
      case 'validityDate':
        setValidityDate(value);
        break;
      default:
        break;
    }
    validate();
  };

  return (
    <div className="form-row">
      <div className="form-group">
        <label>ФИО на латинице</label>
        <input
          type="text"
          placeholder="Ivanov Ivan Ivanovich"
          className={`form-input ${errors.fullNameLatin ? 'is-invalid' : ''}`}
          value={fullNameLatin}
          onChange={(e) => handleChange('fullNameLatin', e.target.value)}
        />
        {errors.fullNameLatin && (
          <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '6px' }}>{errors.fullNameLatin}</div>
        )}
      </div>
      <div className="form-group">
        <label>Гражданство</label>
        <select
          className={`form-select ${errors.citizenship ? 'is-invalid' : ''}`}
          value={citizenship}
          onChange={(e) => handleChange('citizenship', e.target.value)}
        >
          <option value="">Выберите гражданство</option>
          <option value="AF">Афганистан</option>
          <option value="AL">Албания</option>
          <option value="DZ">Алжир</option>
          <option value="AS">Американское Самоа</option>
          <option value="AD">Андорра</option>
          <option value="AO">Ангола</option>
          <option value="AI">Ангилья</option>
          <option value="AQ">Антарктида</option>
          <option value="AG">Антигуа и Барбуда</option>
          <option value="AR">Аргентина</option>
          <option value="AM">Армения</option>
          <option value="AW">Аруба</option>
          <option value="AU">Австралия</option>
          <option value="AT">Австрия</option>
          <option value="AZ">Азербайджан</option>
          <option value="BS">Багамские Острова</option>
          <option value="BH">Бахрейн</option>
          <option value="BD">Бангладеш</option>
          <option value="BB">Барбадос</option>
          <option value="BY">Беларусь</option>
          <option value="BE">Бельгия</option>
          <option value="BZ">Белиз</option>
          <option value="BJ">Бенин</option>
          <option value="BM">Бермуды</option>
          <option value="BT">Бутан</option>
          <option value="BO">Боливия</option>
          <option value="BA">Босния и Герцеговина</option>
          <option value="BW">Ботсвана</option>
          <option value="BV">Остров Буве</option>
          <option value="BR">Бразилия</option>
          <option value="IO">Британская территория Индийского океана</option>
          <option value="BN">Бруней</option>
          <option value="BG">Болгария</option>
          <option value="BF">Буркина-Фасо</option>
          <option value="BI">Бурунди</option>
          <option value="KH">Камбоджа</option>
          <option value="CM">Камерун</option>
          <option value="CA">Канада</option>
          <option value="CV">Кабо-Верде</option>
          <option value="KY">Каймановы острова</option>
          <option value="CF">Центральноафриканская Республика</option>
          <option value="TD">Чад</option>
          <option value="CL">Чили</option>
          <option value="CN">Китай</option>
          <option value="CX">Остров Рождества</option>
          <option value="CC">Кокосовые (Килинг) острова</option>
          <option value="CO">Колумбия</option>
          <option value="KM">Коморы</option>
          <option value="CG">Конго - Киншаса</option>
          <option value="CD">Конго - Браззавиль</option>
          <option value="CK">Острова Кука</option>
          <option value="CR">Коста-Рика</option>
          <option value="CI">Кот-д’Ивуар</option>
          <option value="HR">Хорватия</option>
          <option value="CU">Куба</option>
          <option value="CY">Кипр</option>
          <option value="CZ">Чехия</option>
          <option value="DK">Дания</option>
          <option value="DJ">Джибути</option>
          <option value="DM">Доминика</option>
          <option value="DO">Доминиканская Республика</option>
          <option value="EC">Эквадор</option>
          <option value="EG">Египет</option>
          <option value="SV">Сальвадор</option>
          <option value="GQ">Экваториальная Гвинея</option>
          <option value="ER">Эритрея</option>
          <option value="EE">Эстония</option>
          <option value="ET">Эфиопия</option>
          <option value="FK">Фолклендские острова</option>
          <option value="FO">Фарерские острова</option>
          <option value="FJ">Фиджи</option>
          <option value="FI">Финляндия</option>
          <option value="FR">Франция</option>
          <option value="GF">Французская Гвиана</option>
          <option value="PF">Французская Полинезия</option>
          <option value="TF">Французские Южные территории</option>
          <option value="GA">Габон</option>
          <option value="GM">Гамбия</option>
          <option value="GE">Грузия</option>
          <option value="DE">Германия</option>
          <option value="GH">Гана</option>
          <option value="GI">Гибралтар</option>
          <option value="GR">Греция</option>
          <option value="GL">Гренландия</option>
          <option value="GD">Гренада</option>
          <option value="GP">Гваделупа</option>
          <option value="GU">Гуам</option>
          <option value="GT">Гватемала</option>
          <option value="GG">Гернси</option>
          <option value="GN">Гвинея</option>
          <option value="GW">Гвинея-Бисау</option>
          <option value="GY">Гайана</option>
          <option value="HT">Гаити</option>
          <option value="HM">Остров Хирд и Макдональд</option>
          <option value="VA">Ватикан</option>
          <option value="HN">Гондурас</option>
          <option value="HK">Гонконг</option>
          <option value="HU">Венгрия</option>
          <option value="IS">Исландия</option>
          <option value="IN">Индия</option>
          <option value="ID">Индонезия</option>
          <option value="IR">Иран</option>
          <option value="IQ">Ирак</option>
          <option value="IE">Ирландия</option>
          <option value="IM">Остров Мэн</option>
          <option value="IL">Израиль</option>
          <option value="IT">Италия</option>
          <option value="JM">Ямайка</option>
          <option value="JP">Япония</option>
          <option value="JE">Джерси</option>
          <option value="JO">Иордания</option>
          <option value="KZ">Казахстан</option>
          <option value="KE">Кения</option>
          <option value="KI">Кирибати</option>
          <option value="KP">Северная Корея</option>
          <option value="KR">Южная Корея</option>
          <option value="KW">Кувейт</option>
          <option value="KG">Кыргызстан</option>
          <option value="LA">Лаос</option>
          <option value="LV">Латвия</option>
          <option value="LB">Ливан</option>
          <option value="LS">Лесото</option>
          <option value="LR">Либерия</option>
          <option value="LY">Ливия</option>
          <option value="LI">Лихтенштейн</option>
          <option value="LT">Литва</option>
          <option value="LU">Люксембург</option>
          <option value="MO">Макао</option>
          <option value="MK">Северная Македония</option>
          <option value="MG">Мадагаскар</option>
          <option value="MW">Малави</option>
          <option value="MY">Малайзия</option>
          <option value="MV">Мальдивы</option>
          <option value="ML">Мали</option>
          <option value="MT">Мальта</option>
          <option value="MH">Маршалловы острова</option>
          <option value="MQ">Мартиника</option>
          <option value="MR">Мавритания</option>
          <option value="MU">Маврикий</option>
          <option value="YT">Майотта</option>
          <option value="MX">Мексика</option>
          <option value="FM">Микронезия</option>
          <option value="MD">Молдова</option>
          <option value="MC">Монако</option>
          <option value="MN">Монголия</option>
          <option value="ME">Черногория</option>
          <option value="MS">Монтсеррат</option>
          <option value="MA">Марокко</option>
          <option value="MZ">Мозамбик</option>
          <option value="MM">Мьянма</option>
          <option value="NA">Намибия</option>
          <option value="NR">Науру</option>
          <option value="NP">Непал</option>
          <option value="NL">Нидерланды</option>
          <option value="NC">Новая Каледония</option>
          <option value="NZ">Новая Зеландия</option>
          <option value="NI">Никарагуа</option>
          <option value="NE">Нигер</option>
          <option value="NG">Нигерия</option>
          <option value="NU">Ниуэ</option>
          <option value="NF">Остров Норфолк</option>
          <option value="MP">Северные Марианские острова</option>
          <option value="NO">Норвегия</option>
          <option value="OM">Оман</option>
          <option value="PK">Пакистан</option>
          <option value="PW">Палау</option>
          <option value="PS">Палестинские территории</option>
          <option value="PA">Панама</option>
          <option value="PG">Папуа-Новая Гвинея</option>
          <option value="PY">Парагвай</option>
          <option value="PE">Перу</option>
          <option value="PH">Филиппины</option>
          <option value="PN">Питкэрн</option>
          <option value="PL">Польша</option>
          <option value="PT">Португалия</option>
          <option value="PR">Пуэрто-Рико</option>
          <option value="QA">Катар</option>
          <option value="RE">Реюньон</option>
          <option value="RO">Румыния</option>
          <option value="RU">Россия</option>
          <option value="RW">Руанда</option>
          <option value="BL">Сен-Бартелеми</option>
          <option value="SH">Остров Святой Елены</option>
          <option value="KN">Сент-Китс и Невис</option>
          <option value="LC">Сент-Люсия</option>
          <option value="MF">Сент-Мартен</option>
          <option value="PM">Сен-Пьер и Микелон</option>
          <option value="VC">Сент-Винсент и Гренадины</option>
          <option value="WS">Самоа</option>
          <option value="SM">Сан-Марино</option>
          <option value="ST">Сан-Томе и Принсипи</option>
          <option value="SA">Саудовская Аравия</option>
          <option value="SN">Сенегал</option>
          <option value="RS">Сербия</option>
          <option value="SC">Сейшелы</option>
          <option value="SL">Сьерра-Леоне</option>
          <option value="SG">Сингапур</option>
          <option value="SX">Синт-Мартен</option>
          <option value="SK">Словакия</option>
          <option value="SI">Словения</option>
          <option value="SB">Соломоновы острова</option>
          <option value="SO">Сомали</option>
          <option value="ZA">Южная Африка</option>
          <option value="GS">Южная Джорджия и Южные Сандвичевы острова</option>
          <option value="SS">Южный Судан</option>
          <option value="ES">Испания</option>
          <option value="LK">Шри-Ланка</option>
          <option value="SD">Судан</option>
          <option value="SR">Суринам</option>
          <option value="SJ">Шпицберген и Ян-Майен</option>
          <option value="SZ">Эсватини</option>
          <option value="SE">Швеция</option>
          <option value="CH">Швейцария</option>
          <option value="SY">Сирия</option>
          <option value="TW">Тайвань</option>
          <option value="TJ">Таджикистан</option>
          <option value="TZ">Танзания</option>
          <option value="TH">Таиланд</option>
          <option value="TL">Тимор-Лешти</option>
          <option value="TG">Того</option>
          <option value="TK">Токелау</option>
          <option value="TO">Тонга</option>
          <option value="TT">Тринидад и Тобаго</option>
          <option value="TN">Тунис</option>
          <option value="TR">Турция</option>
          <option value="TM">Туркменистан</option>
          <option value="TC">Тёркс и Кайкос</option>
          <option value="TV">Тувалу</option>
          <option value="UG">Уганда</option>
          <option value="UA">Украина</option>
          <option value="AE">Объединённые Арабские Эмираты</option>
          <option value="GB">Великобритания</option>
          <option value="US">США</option>
          <option value="UM">Внешние малые острова США</option>
          <option value="UY">Уругвай</option>
          <option value="UZ">Узбекистан</option>
          <option value="VU">Вануату</option>
          <option value="VE">Венесуэла</option>
          <option value="VN">Вьетнам</option>
          <option value="VG">Виргинские острова (Британские)</option>
          <option value="VI">Виргинские острова (США)</option>
          <option value="WF">Уоллис и Футуна</option>
          <option value="EH">Западная Сахара</option>
          <option value="YE">Йемен</option>
          <option value="ZM">Замбия</option>
          <option value="ZW">Зимбабве</option>
        </select>
        {errors.citizenship && (
          <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '6px' }}>{errors.citizenship}</div>
        )}
      </div>
      <div className="form-group">
        <label>Тип документа</label>
        <select
          className={`form-select ${errors.documentType ? 'is-invalid' : ''}`}
          value={documentType}
          onChange={(e) => handleChange('documentType', e.target.value)}
        >
          <option value="">Выберите тип документа</option>
          <option value="passport">Паспорт</option>
          <option value="id">ID-карта</option>
          <option value="visa">Виза</option>
        </select>
        {errors.documentType && (
          <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '6px' }}>{errors.documentType}</div>
        )}
      </div>
      <div className="form-group">
        <label>Введите номер загранпаспорта</label>
        <input
          type="text"
          placeholder="123456789"
          className={`form-input ${errors.documentNumber ? 'is-invalid' : ''}`}
          value={documentNumber}
          onChange={(e) => handleChange('documentNumber', e.target.value)}
        />
        {errors.documentNumber && (
          <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '6px' }}>{errors.documentNumber}</div>
        )}
      </div>
      <div className="form-group">
        <label>Дата действительности документа</label>
        <input
          type="date"
          className={`form-input ${errors.validityDate ? 'is-invalid' : ''}`}
          value={validityDate}
          onChange={(e) => handleChange('validityDate', e.target.value)}
        />
        {errors.validityDate && (
          <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '6px' }}>{errors.validityDate}</div>
        )}
      </div>
      <button type="submit" className="button1" disabled={Object.keys(errors).length > 0}>
        Следующий шаг <span style={{ fontSize: '18px', fontWeight: 'bold' }}>›</span>
      </button>
    </div>
  );
}

function StepThreeForm({ fullName, dob, stepTwoData, onBack, gender, phoneNumber, onConfirm }) {
  const [operatorId] = useState('2426025');
  const [contactMethod, setContactMethod] = useState('');
  const [contactValue, setContactValue] = useState('');
  const [contactError, setContactError] = useState('');
  const [isAgreed, setIsAgreed] = useState(false);
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);

  const validateContact = (method, value) => {
    if (!method) return 'Выберите способ получения ответа';
    if (!value) return 'Укажите контактные данные';
    switch (method) {
      case 'telegram':
        if (!/^@[\w]+$/.test(value)) return 'Введите корректный Telegram ник (начиная с @)';
        break;
      case 'whatsapp':
        if (!/^\+\d{10,12}$/.test(value)) return 'Введите корректный номер WhatsApp (например, +79991234567)';
        break;
      case 'email':
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) return 'Введите корректный email';
        break;
      default:
        return '';
    }
    return '';
  };

  const handleContactChange = (e) => {
    const value = e.target.value;
    setContactValue(value);
    const error = validateContact(contactMethod, value);
    setContactError(error);
  };

  const handleMethodChange = (e) => {
    setContactMethod(e.target.value);
    setContactValue('');
    setContactError(validateContact(e.target.value, contactValue));
  };

  const handleConfirm = () => {
    const error = validateContact(contactMethod, contactValue);
    if (error) {
      setContactError(error);
      return;
    }
    if (!isAgreed) {
      alert('Пожалуйста, согласитесь с условиями обработки персональных данных.');
      return;
    }

    if (!paymentConfirmed) {
      setPaymentConfirmed(true);
      alert('Оплата в размере 198 Р подтверждена. Нажмите "Подтвердить" еще раз для отправки запроса.');
      return;
    }

    const timestamp = new Date().toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Yekaterinburg'
    }).replace(',', '');

    const formData = {
      fullName,
      gender,
      dob,
      phoneNumber,
      citizenship: stepTwoData.citizenship,
      fullNameLatin: stepTwoData.fullNameLatin, // Добавлено поле fullNameLatin
      documentType: stepTwoData.documentType,
      documentNumber: stepTwoData.documentNumber,
      validityDate: stepTwoData.validityDate,
      contactMethod,
      contactValue,
      timestamp,
      country: "RF"
    };

    onConfirm(formData);
  };

  return (
    <div className="form-row">
      <div className="form-group step-three-container" style={{ width: '100%', padding: '20px', background: '#f5f5f5', borderRadius: '8px', height: 'auto', display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <div>
          <label style={{ fontSize: '16px', fontWeight: 'bold' }}>Отчет №: {operatorId}</label>
        </div>
        <div>
          <p style={{ margin: '10px 0', fontSize: '14px' }}>Куда вы хотите получить ответ?</p>
          <div style={{ display: 'flex', gap: '15px', marginBottom: '10px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input type="radio" name="contact" value="telegram" onChange={handleMethodChange} style={{ margin: 0 }} /> Telegram
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input type="radio" name="contact" value="whatsapp" onChange={handleMethodChange} style={{ margin: 0 }} /> WhatsApp
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input type="radio" name="contact" value="email" onChange={handleMethodChange} style={{ margin: 0 }} /> Email
            </label>
          </div>
        </div>
        <div>
          <p style={{ margin: '10px 0', fontSize: '14px' }}>Куда направить официальный ответ по вашему запросу?</p>
          <input
            type="text"
            placeholder={contactMethod === 'telegram' ? '@Username' : contactMethod === 'whatsapp' ? '+Number' : 'example@example.com'}
            value={contactValue}
            onChange={handleContactChange}
            style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px' }}
            className={contactError ? 'is-invalid' : ''}
          />
          {contactError && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{contactError}</div>}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px' }}>
          <button className="button1" onClick={onBack} style={{ padding: '10px 20px', marginRight: '10px' }}>
            Назад <span style={{ fontSize: '18px', fontWeight: 'bold' }}>‹</span>
          </button>
          <button
            className="button1 booldog"
            onClick={handleConfirm}
            disabled={!!contactError || !contactMethod || !contactValue || !isAgreed || (paymentConfirmed && !fullName)}
            style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px' }}
          >
            Подтвердить оплату — 198 Р
          </button>
        </div>
        <div style={{ marginTop: '10px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <input
              type="checkbox"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
              style={{ margin: 0 }}
            /> Я согласен с <a href="#" style={{ color: '#007bff', textDecoration: 'none' }}>условиями обработки персональных данных</a>.
          </label>
        </div>
      </div>
    </div>
  );
}

function Main() {
  const [isNameValid, setIsNameValid] = useState(false);
  const [showCookieNotice, setShowCookieNotice] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [isStepTwoValid, setIsStepTwoValid] = useState(false);
  const [formData, setFormData] = useState({ fullName: '', dob: '', gender: '', phoneNumber: '', stepTwoData: {} });
  const [showChat, setShowChat] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');

  const getUserId = () => {
    let userId = localStorage.getItem('userId');
    if (!userId) {
      userId = uuidv4();
      localStorage.setItem('userId', userId);
    }
    return userId;
  };
  const userId = getUserId();

  useEffect(() => {
    const syncUserId = async () => {
      try {
        await axios.post('http://localhost:5001/set_user_id', { userId });
        console.log('User ID синхронизирован с сервером:', userId);
      } catch (error) {
        console.error('Ошибка синхронизации userId:', error);
        try {
          await axios.post('http://localhost:5000/set_user_id', { userId });
          console.log('User ID синхронизирован с сервером 5000:', userId);
        } catch (e) {
          console.error('Ошибка синхронизации с сервером 5000:', e);
        }
      }
    };
    syncUserId();
  }, [userId]);

  useEffect(() => {
    if (showChat) {
      const fetchMessages = async () => {
        try {
          const response = await axios.get(`http://localhost:5000/messages?userId=${userId}`);
          setMessages(response.data);
        } catch (error) {
          console.error('Ошибка загрузки сообщений:', error);
        }
      };
      fetchMessages();
      const interval = setInterval(fetchMessages, 5000);
      return () => clearInterval(interval);
    }
  }, [showChat, userId]);

  const handleCookieAccept = () => {
    setShowCookieNotice(false);
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    if (currentStep === 1 && isNameValid) {
      setCurrentStep(2);
    } else if (currentStep === 2 && isStepTwoValid) {
      setCurrentStep(3);
    }
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const updateFormData = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };

  const handleSendMessage = async () => {
    if (!newMessage.trim()) return;

    const message = {
      id: Date.now().toString(),
      sender: 'user',
      text: newMessage,
      timestamp: new Date().toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Asia/Yekaterinburg'
      }).replace(',', ''),
      userId
    };

    try {
      await axios.post('http://localhost:5000/send_message', message);
      setMessages([...messages, message]);
      setNewMessage('');
    } catch (error) {
      console.error('Ошибка отправки сообщения:', error);
    }
  };

  const handleConfirm = async (formData) => {
    const submitData = { ...formData, userId };
    try {
      const response = await axios.post('http://localhost:5000/submit', submitData);
      if (response.data.message) {
        alert(`Проверка завершена. Отчет будет отправлен на ${submitData.contactMethod}: ${submitData.contactValue}`);
        setCurrentStep(4);
      } else {
        alert('Ошибка при отправке запроса: ' + response.data.error);
      }
    } catch (error) {
      alert('Ошибка сети: ' + error.message);
    }
  };

  return (
    <div className="entry-ban-container">
      <section className="form-section">
        <div className="step-indicator">
          <span className="step-text">ШАГ {currentStep} / 3</span>
        </div>
        <h1 className="main-title">
          <span className="highlight">ПРОВЕРКА НАЛИЧИЯ ЗАПРЕТА И СРОКОВ</span> НА ВЪЕЗД В РБ И РФ
        </h1>
        <p className="description">
          Для проверки запрета или ограничений заполните данные ниже. Отчет будет сформирован из официальных баз данных МВД, ФМС. Формирование
          регламентируется ФЗ 109: «О миграционном учете иностранных граждан и лиц без гражданства в Российской Федерации»
        </p>
        <form className="ban-form" onSubmit={handleNextStep}>
          {currentStep === 1 && (
            <div className="form-row">
              <FullNameInput onValidChange={setIsNameValid} onChange={(value) => updateFormData({ fullName: value })} />
              <div className="form-group">
                <label>Ваш пол</label>
                <select 
                  className="form-select" 
                  defaultValue=""
                  onChange={(e) => updateFormData({ gender: e.target.value })}
                >
                  <option disabled value="">Выберите пол</option>
                  <option value="male">Мужской</option>
                  <option value="female">Женский</option>
                </select>
              </div>
              <div className="form-group">
                <label>Дата рождения</label>
                <input type="date" className="form-input" onChange={(e) => updateFormData({ dob: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Номер телефона</label>
                <input
                  type="tel"
                  placeholder="+1234567890"
                  className="form-input"
                  value={formData.phoneNumber}
                  onChange={(e) => updateFormData({ phoneNumber: e.target.value })}
                />
              </div>
              <button type="submit" className="button1" disabled={!isNameValid}>
                Следующий шаг <span style={{ fontSize: '18px', fontWeight: 'bold' }}>›</span>
              </button>
            </div>
          )}
          {currentStep === 2 && <StepTwoForm onValidChange={setIsStepTwoValid} onDataChange={(data) => updateFormData({ stepTwoData: data })} />}
          {currentStep === 3 && (
            <StepThreeForm 
              fullName={formData.fullName} 
              dob={formData.dob} 
              stepTwoData={formData.stepTwoData} 
              onBack={handleBack}
              gender={formData.gender}
              phoneNumber={formData.phoneNumber}
              onConfirm={handleConfirm}
            />
          )}
          {currentStep === 4 && (
            <div className="step">
              <h2>Завершение</h2>
              <p>Ваш запрос успешно отправлен! Ожидайте ответа на указанный контакт.</p>
            </div>
          )}
        </form>
        <div className="info-block">
          <p>
            ФЗ 109: «О миграционном учете иностранных граждан и лиц без гражданства в Российской Федерации», каждый иностранный гражданин вправе въехать
            на территорию Российской Федерации, за исключением ряда случаев. Для проверки каждого иностранного гражданина доступна онлайн проверка запрета
            въезда на территорию РФ.
          </p>
        </div>
      </section>

      <section className="stats-section">
        <div className="stats-header">
          <h2>СТАТИСТИКА ПРОВЕРОК ЗАПРЕТА ВЪЕЗДА В РФ</h2>
        </div>
        <p className="stats-description">
          Статистика обновляется каждые 20 минут. Данные формируются исходя из данных проверок, совершенных на нашем портале за последние 24 часа.
        </p>
        <RandomCheckTable />
      </section>

      {showCookieNotice && (
        <div className="cookie-notice">
          <div className="cookie-content">
            <div className="cookie-icon">🍪</div>
            <div className="cookie-text">
              <h3>Этот сайт использует файлы cookie</h3>
              <p>Мы используем файлы cookie, чтобы улучшить ваш опыт. Продолжая использовать сайт, вы соглашаетесь с нашей политикой использования cookie.</p>
              <button className="cookie-btn" onClick={handleCookieAccept}>
                Принять
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="report-wrapper">
        <div className="report-container">
          <div className="report-image">
            <img src={a2} alt="" />
            <a href={a1} className="report-image-a" download="report.pdf">
              Смотреть пример 📑
            </a>
          </div>
          <div className="report-text">
            <h2>ПРИМЕР СПРАВКИ “РАЗРЕШЕНИЕ НА ВЪЕЗД В РФ”</h2>
            <p className="report-text-p">
              Пример сформированного отчета сервисом fsspru, в отчете отражено как приставы наложили ограничения на выезд за границу, все данные являются
              вымышленными любые совпадения с реальными людьми случайны
            </p>
            <div className="report-result">
              <h3>РЕЗУЛЬТАТ ПРОВЕРКИ</h3>
              <p className="report-text-p">Согласно данным полученным в МВД от 12.04.2020 в 12:48</p>
              <p className="report-text-p">Гражданину: {formData.fullName || 'Не указано'}</p>
              <p className="report-text-p">ФИО на латинице: {formData.stepTwoData?.fullNameLatin || 'Не указано'}</p> {/* Добавлено отображение */}
              <p className="report-text-p">Дата рождения: {formData.dob || 'Не указана'}</p>
              <p className="report-text-p">Номер телефона: {formData.phoneNumber || 'Не указан'}</p>
              <p className="report-text-p">Регион: Московская область</p>
              <p className="report-text-p">
                <a href="#" className="report-check-link">Въезд в РФ: Разрешен</a>
              </p>
            </div>
            <div className="report-result2">
              <p className="report-note">
                Согласно статистике ФМС – 65% граждан имеют запрет на въезд на территорию РФ. Рекомендуем произвести проверку.
              </p>
              <a href="#" className="report-check-link">Сделать проверку</a>
            </div>
          </div>
        </div>
      </div>

      <div className="app-container2">
        <h1 className="main-title">
          <span className="highlight">КАК ПРОВЕРИТЬ</span> НА ВЪЕЗД НА ГРАНИЦУ РФ
        </h1>
        <p className="description">Для проверки ограничений на въезд в РФ отправьте онлайн заявку в базу ФМС.</p>
        <p className="description2">
          Если Вам потребуется справка для подтверждения возможности (разрешения) въезда на территорию Российской Федерации, вы сможете получить ее на
          последнем шаге.
        </p>
        <p className="description2">
          Если у вас остались вопросы, вы можете задать их отправив письмо на адрес электронной почты info@fsspru.net
        </p>
        <div className="app-container">
          <StepCard number="1" text="Укажите в заявке свои данные, которые указаны выше в форме." />
          <StepCard number="2" text="Рекомендуется указывать полный список данных, бывают совпадения по ФИО по разным регионам." />
          <StepCard number="3" text="Дождитесь обработки данных из базы ФМС, это займет не более 5 минут." />
        </div>
      </div>

      {/* <button
        className="chat-button"
        onClick={() => setShowChat(!showChat)}
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          zIndex: 1000
        }}
      >
        💬
      </button> */}

      {showChat && (
        <div
          className="chat-window"
          style={{
            position: 'fixed',
            bottom: '80px',
            left: '20px',
            width: '300px',
            height: '400px',
            backgroundColor: '#fff',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1000
          }}
        >
          <div
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              padding: '10px',
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <span>Чат с менеджером</span>
            <button
              onClick={() => setShowChat(false)}
              style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer' }}
            >
              ✕
            </button>
          </div>
          <div
            style={{
              flex: 1,
              padding: '10px',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px'
            }}
          >
            {messages.map((msg) => (
              <div
                key={msg.id}
                style={{
                  alignSelf: msg.sender === 'user' ? 'flex-end' : 'flex-start',
                  backgroundColor: msg.sender === 'user' ? '#007bff' : '#e9ecef',
                  color: msg.sender === 'user' ? 'white' : 'black',
                  padding: '8px 12px',
                  borderRadius: '10px',
                  maxWidth: '70%'
                }}
              >
                <div>{msg.text}</div>
                <div style={{ fontSize: '10px', marginTop: '5px', opacity: 0.7 }}>
                  {msg.timestamp}
                </div>
              </div>
            ))}
          </div>
          <div style={{ padding: '10px', display: 'flex', gap: '10px', borderTop: '1px solid #ddd' }}>
            <input
              type="text"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="Введите сообщение..."
              style={{ flex: 1, padding: '8px', borderRadius: '5px', border: '1px solid #ddd' }}
            />
            <button
              onClick={handleSendMessage}
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Отправить
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Main;